import get from 'lodash/get';
import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';
import {
  PROGRAM_VALUE_TYPES,
  STATUS_FILTER_TYPES,
} from '../../constants/props';

const supportedActions = [
  'SET_AVAILABLE_FILTERS',
  'SET_TYPE',
  'SET_PROGRAM_VALUE',
  'SET_STATUS',
  'SET_SEARCH_QUERY',
  'CLEAR',
  'RESTORE',
];

export const consts = createConsts('board', 'filters', ...supportedActions);
export const actions = createActions(consts);

// init
export const initialState = {
  availableFilters: [],
  type: null,
  programValue: PROGRAM_VALUE_TYPES.all,
  status: STATUS_FILTER_TYPES.all,
  searchQuery: null,
};

// persistence
const getPersistedState = () => {
  const storedUser = window.storage.getItem('user'); // eslint-disable-line jsx-control-statements/jsx-jcs-no-undef
  const { id } = storedUser ? JSON.parse(storedUser) : {};

  if (id) {
    const persistedState = window.storage.getItem(`board-filters-${id}`); // eslint-disable-line jsx-control-statements/jsx-jcs-no-undef
    const state = persistedState ? JSON.parse(persistedState) : initialState;

    return {
      ...initialState,
      ...state,
      availableFilters: [],
      searchQuery: null,
    };
  }

  return initialState;
};

// reducer
const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SET_AVAILABLE_FILTERS:
      return { ...state, availableFilters: payload };
    case consts.SET_TYPE:
      return { ...state, type: payload };
    case consts.SET_PROGRAM_VALUE:
      return { ...state, programValue: payload };
    case consts.SET_STATUS:
      return { ...state, status: payload };
    case consts.SET_SEARCH_QUERY:
      return { ...state, searchQuery: payload };
    case consts.CLEAR:
      return initialState;
    case consts.RESTORE:
      return getPersistedState();
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/board/filters.js